import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, Button, Box } from '@material-ui/core';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { DialogCompanyApproval, DialogConfirm } from '../../../components/Dialog';
import ToastStr from '../../../request/toastStr';
import { COLORS } from '../../../shared/Theme';
import { member as v_member, basic, Values, SNACKBAR_TIME } from '../../../request/values';
import { TitleBackBar } from '../../../shared/header/TitleBar';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	paper: {
		// marginTop: theme.spacing(8),
		marginTop: '3vh',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	button: {
		paddingRight: theme.spacing(1),
		paddingLeft: theme.spacing(1),
	},
	back: {
		float: 'left',
		width: '20%',
	},
	titleWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		float: 'left',
		textAlign: 'center',
		width: '66.6666666%',
	},

	title: {
		fontSize: 30,
		color: `${COLORS.WATER_BLUE}`,
		// marginBottom: '0.5vh',
		// alignItems: 'center',
		// flexGrow: 1,
		// textAlign: 'center',
	},

	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	appList: {
		backgroundColor: `${COLORS.LIGHT_GREY}`,
		padding: '14px 14px',
		[theme.breakpoints.up('md')]: {
			backgroundColor: `${COLORS.LIGHT_GREY}`,
			padding: '22px 28px',
		},
	},
	edit_button: {
		height: 'auto',
		borderRadius: '5px',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		color: `${COLORS.WHITE}`,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		padding: '1vw',
		...theme.typography.body1,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		width: 'auto',
	},
	buttonLabel1: {
		color: `${COLORS.BROWNISH_GREY}`,
		fontSize: 18,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
		padding: 0,
		flexGrow: 4,
	},
	buttonLabel2: {
		color: `${COLORS.BROWNISH_GREY}`,
		fontSize: 14,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
		padding: 0,
	},
	buttonLabel3: {
		color: `${COLORS.WATER_BLUE}`,
		fontSize: 14,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
		padding: 0,
	},
	submit: {
		height: 60,
		margin: theme.spacing(3, 0, 2),
		borderRadius: '27px',
		boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'solid 0.5px #cfd4d9',
	},
}));

type iAppList = {
	application_date: string;
	member_email: string;
	member_name: string;
	member_phone: string;
};

const CompanyAppList: React.FC<any> = (props) => {
	const classes = useStyles();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const { member } = props;
	const history = useHistory();
	const { t } = useTranslation(['student', 'common']);
	const [appList, setAppList] = useState<iAppList[]>([]);
	const [approvalDialog, setApprovalDialog] = useState<boolean | number>(false);
	const [declineDialog, setDeclineDialog] = useState<boolean | number>(false);

	const handleClose = (key: string) => {
		if (key === 'approvalDialog') setApprovalDialog((prevState) => false);
		else if (key === 'declineDialog') {
			setDeclineDialog((prevState) => false);
		}
	};

	const handleDeclineOpen = (index: number) => {
		if (declineDialog === false) {
			setDeclineDialog((prevState) => index);
		}
	};

	const getAppList = () => {
		let url = new URL(basic.server + v_member.member + v_member.company_app_list);
		let params = { companyNum: member.companyNum, classCode: member.classCode };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data) => {
				console.log(data);
				setAppList(data.appList);
			});
	};

	const postUserCompanyUpdate = (index: number) => {
		axios({
			method: 'POST',
			data: {
				email: appList[index].member_email,
				companyNum: member.companyNum,
			},
			withCredentials: true,
			url: SERVER + v_member.member + v_member.company_approval,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code === Values.SUCCESS_CODE) {
					enqueueSnackbar(ToastStr.COMPANY_APPROVAL_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME });
					getAppList();
				} else if (data.code === Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.COMPANY_APPROVAL_FAIL_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				} else {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: 'error', autoHideDuration: SNACKBAR_TIME });
				}
			});
	};

	const postCompanyAppDelete = () => {
		if (declineDialog !== false) {
			axios({
				method: 'POST',
				data: {
					email: appList[declineDialog as number].member_email,
					companyNum: member.companyNum,
				},
				withCredentials: true,
				url: SERVER + v_member.member + v_member.company_decline,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					if (data.code === Values.SUCCESS_CODE) {
						enqueueSnackbar(ToastStr.COMPANY_DECLINE_SUCCESS_STR, {
							variant: 'success',
							autoHideDuration: SNACKBAR_TIME,
						});
						getAppList();
					} else if (data.code === Values.FAIL_CODE) {
						enqueueSnackbar(ToastStr.COMPANY_DECLINE_FAIL_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
					} else {
						enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: 'error', autoHideDuration: SNACKBAR_TIME });
					}
				});
		}
		handleClose('declineDialog');
	};

	const refusal = () => {
		postCompanyAppDelete();
		handleClose('declineDialog');
	};

	useEffect(() => {
		getAppList();
	}, []);

	const moveEditMember = () => {
		history.push({
			pathname: '/CompanyEditMember',
		});
	};

	return (
		<div className="content">
			<TitleBackBar history={history} title={t('companyAppList.title')} titleIcon="profile_green" />
			<div style={{ textAlign: 'right', marginLeft: 'auto', paddingBottom: '1vh', paddingRight: '6vw' }}>
				<Button className={classes.edit_button} onClick={moveEditMember}>
					{t('companyAppList.editMember')}
				</Button>
			</div>
			<div className={classes.paper}>
				<List className={classes.form}>
					{appList != null &&
						appList.map((item: any, index: number) => {
							return <AppListItem name={item.member_name} approval={() => postUserCompanyUpdate(index)} refusal={() => handleDeclineOpen(index)} />;
						})}
				</List>
				<div style={{ height: '10vh' }}></div>
			</div>
			<DialogConfirm
				open={declineDialog === false ? false : true}
				handleClose={() => handleClose('declineDialog')}
				title={t('companyAppList.title')}
				context={
					declineDialog === false
						? t('companyAppList.declineConfirmTitle')
						: t('companyAppList.declineConfirmContext', { name: appList[declineDialog as number].member_name })
				}
				yesConfirm={refusal}
				noConfirm={() => handleClose('declineDialog')}
			/>
			<DialogCompanyApproval
				open={approvalDialog === false ? false : true}
				handleClose={() => handleClose('approvalDialog')}
				memberName={approvalDialog === false ? '' : appList[approvalDialog as number].member_name}
				companyType={member.companyType}
				noConfirm={() => handleClose('approvalDialog')}
				yesConfirm={postUserCompanyUpdate}
			/>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { name, refusal, approval } = props;
	const { t } = useTranslation('common');

	return (
		<ListItem className={classes.appList}>
			<Box className={classes.buttonLabel1} data-testid={`company-app-list-name-${name}`}>
				{name}
			</Box>
			<Box flexGrow={1} textAlign="right">
				<Button onClick={refusal} className={classes.buttonLabel2}>
					{t('common.decline')}
				</Button>
			</Box>
			<Box flexGrow={1} textAlign="right">
				<Button onClick={approval} className={classes.buttonLabel3} data-testid={`company-app-list-approve-btn-${name}`}>
					{t('common.approve')}
				</Button>
			</Box>
		</ListItem>
	);
};

export default CompanyAppList;
